"use client";

import React, { useState } from "react";
import { ChevronDown, ChevronUp, Star } from "lucide-react";
import { Card } from "@/components/ui/card";
const sectors = [{
  value: "Government & Enterprise",
  label: "Security governance, resilient infrastructure and compliance-aligned solutions for public and enterprise organizations."
}, {
  value: "FinTech & RegTech Enablement",
  label: "Technology and cybersecurity solutions supporting AML/KYC enablement, secure integrations and compliance-driven digital platforms."
}, {
  value: "Secure Transformation",
  label: "Cybersecurity, infrastructure modernization, API security and digital transformation enablement."
}];
const faqs = [{
  question: "What core consultancy services does FETC provide?",
  answer: "FETC provides specialized consultancy in cybersecurity governance, GRC, infrastructure modernization, digital transformation, and secure technology architecture for government and enterprise sectors."
}, {
  question: "How does FETC ensure compliance with UAE regulatory standards?",
  answer: "We help organizations align with UAE Information Assurance (UAE IA), issued by the UAE Cybersecurity Council (CSC), and other local and international standards through comprehensive risk assessments, control readiness audits, and governance framework development."
}, {
  question: "Can FETC support financial institutions with FinTech integrations?",
  answer: "Yes, we specialize in secure financial technology enablement, including API security, AML/KYC technology integration, and compliance-driven digital platform modernization."
}, {
  question: "What is FETC's approach to infrastructure and cloud security?",
  answer: "We focus on building resilient, secure-by-design environments using zero-trust principles, secure cloud migration strategies, and robust network architecture modernization."
}, {
  question: "How can our organization engage FETC for a project?",
  answer: "You can request a formal consultation through our contact form or reach out directly to our Abu Dhabi office to discuss your specific technology and security requirements."
}];
export default function ExperienceHighlights() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section data-section-id="257528" id="experience-highlights" className="py-16 md:py-24 bg-secondary text-foreground">
      <div className="page-container">
        
        {}
        <div className="bg-[#0B1220] border border-white/10 border-t-2 border-t-[#0F62FE] rounded-lg p-8 md:p-10 mt-4 mb-20 max-w-6xl mx-auto shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center divide-y md:divide-y-0 md:divide-x divide-white/5">
            {sectors.map((sector, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center pt-10 md:pt-0 first:pt-0 md:px-4">
                <div className="flex items-center justify-center mb-4">
                  <span className="text-2xl md:text-3xl font-bold font-default text-white leading-tight">
                    {sector.value}
                  </span>
                </div>
                <span className="text-sm text-white/90 font-default leading-relaxed max-w-[280px]">
                  {sector.label}
                </span>
              </div>)}
          </div>
        </div>

        {}
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h3 className="text-sm font-bold tracking-widest uppercase text-primary mb-3 font-mono">
              Consultancy FAQ
            </h3>
            <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground">
              Expert Insights & Common Inquiries
            </h2>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq, i) => <Card key={i} data-index={i} className="bg-card border border-border shadow-sm cursor-pointer transition-all duration-300 hover:bg-card hover:shadow-md py-0 gap-0 overflow-hidden rounded-md" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                <div className="flex flex-row items-center justify-between p-5 md:p-6">
                  <h4 className="text-base md:text-lg font-semibold font-default pr-4 text-foreground">
                    {faq.question}
                  </h4>
                  <div className="shrink-0 bg-secondary p-2 rounded-md text-primary">
                    {openIndex === i ? <ChevronUp className="size-4" /> : <ChevronDown className="size-4" />}
                  </div>
                </div>
                {openIndex === i && <div className="px-5 md:px-6 pb-5 md:pb-6 text-foreground leading-relaxed font-default">
                    {faq.answer}
                  </div>}
              </Card>)}
          </div>
        </div>

      </div>
    </section>;
}